import './InternalPage.css';
import { useLocation, useParams } from 'react-router-dom';
import SideMenu from './SideMenu';
import "./ResearchGroupInfo.css";
import HTMLPage from './HTMLPage';

export default function InternalPage(props) {

    const subMenu = [
        { path: "publication", hu: "Publikálás", en: "Publication"},
        { path: "projects", hu: "Pályázatok", en: null},
        { path: "subscriptions", hu: "Szakirodalmi elérés", en: "Subscriptions"},
        { path: "services", hu: "Szolgáltatások", en: "Services"},
        { path: "scientometrics", hu: "Tudománymetria", en: "Scientometrics"},
        { path: "unkp", hu: "ÚNKP", en: null},
    ];

    const location = useLocation();
    const param = new URLSearchParams(location.search);
    const lang = param.get("lang") === "en" ? "en" : "hu";

    const { selectedMenu="publication" } = useParams();
    const validMenu = subMenu.find(d => d.path === selectedMenu);

    return (
        <div id="internal-main" className="page-main">
            <SideMenu menuItems={subMenu} selectedMenuItem={selectedMenu} pathPrefix="/internal/" lang={lang} />
            <div className="content-panel">
                <div >
                    {validMenu && <HTMLPage prefix="./internal/" file={selectedMenu} lang={lang} />}
                </div>
            </div>            
        </div>        
    );
}
